export default __webpack_public_path__ + "static/hyundai_white-f997522c9c44d6b29e80790ba2486cb3.jpg";